import { logger, metrics } from 'lib/slardar-utils'

import { getDomainBlackList, getDomainWhiteList } from './constant'

/* eslint-disable complexity */
export function decodeUri(originStr: string): string | null {
  let origin = originStr
  if (!origin) {
    return null
  }
  const blackList = getDomainBlackList()
  // 匹配到黑名单，不进行打点
  if (blackList.some(domain => origin.includes(`${domain}/`))) {
    return null
  }
  const whiteList = getDomainWhiteList()
  if (!whiteList.some(domain => origin.includes(`.${domain}/`))) {
    logger.warn(`[motor/pc/view-image] not in domain white list url=${origin}`)
    metrics.counter('tosUri.decode.ignore', { url: origin })
    return null
  }

  /* eslint-disable prefer-destructuring */
  origin = origin.split('?')[0]
  // 原格式，如：https://sf1-ttcdn-tos.pstatp.com/obj/developer-baas/baas/ttcqr5/de057af34f101a4e_1605090421476.png
  const objUrlRegex = /\/obj\/(.*)/

  if (objUrlRegex.test(origin)) {
    const matches = origin.match(objUrlRegex)
    if (matches?.[1]) {
      return matches[1]
    }
  }
  // 遗留的图片格式0，如：https://p3.pstatp.com/large/1bf6000409257e13550d
  const legacyUrlRegex0 = /\/(?:origin|large|medium|thumb|img)\/([0-9a-f]{9,})/
  if (legacyUrlRegex0.test(origin)) {
    const matches = origin.match(legacyUrlRegex0)
    if (matches?.[1]) {
      return `mosaic-legacy/${matches[1]}`
    }
  }
  // 遗留的图片格式，如：https://p3.pstatp.com/avatar/100x100/1dd5000048d6334c26b4.png
  const legacyUrlRegex1 = /\d+x\d+\/([0-9a-f]{9,})/
  if (legacyUrlRegex1.test(origin)) {
    const matches = origin.match(legacyUrlRegex1)
    if (matches?.[1]) {
      return `mosaic-legacy/${matches[1]}`
    }
  }

  // 遗留的图片格式2，如：https://p7.pstatp.com/large/pgc-image/a8c9c8f743174b259f21915df49f19a7
  const legacyUrlRegex2 = /[a-z]+\/([0-9a-z-]+)\/([0-9a-f]{9,})/
  if (legacyUrlRegex2.test(origin)) {
    const matches = origin.match(legacyUrlRegex2)
    if (matches && matches[1] && matches[2]) {
      return `${matches[1]}/${matches[2]}`
    }
  }

  // 遗留图片格式3，'https://p7.pstatp.com/list/300x196/pgc-image/123432866b864bc295ac12102aaf395f'
  const legacyUrlRegex3 = /list\/\d+x\d+\/([0-9a-z-]+)\/([0-9a-f]{9,})/
  if (legacyUrlRegex3.test(origin)) {
    const matches = origin.match(legacyUrlRegex3)
    if (matches && matches[1] && matches[2]) {
      return `${matches[1]}/${matches[2]}`
    }
  }

  // 常见的图片格式，如：https://p7.pstatp.com/large/pgc-image/a8c9c8f743174b259f21915df49f19a7
  const normalUrlRegex = /(?:img)\/([0-9a-z-]+)\/([0-9a-f]{9,})/
  const matches = origin.match(normalUrlRegex)
  if (matches && matches[1] && matches[2]) {
    return `${matches[1]}/${matches[2]}`
  }
  logger.warn(`[motor/pc/view-image] can not decode url=${origin}`)
  metrics.counter('tosUri.decode.miss', { url: origin })
  return null
}
